import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './DemoRequestHeader.css';

function DemoRequestHeader() {
    const { t } = useTranslation();

    return (
        <div className='demo-request-header' style={{ backgroundImage: 'url(/images/homepage-header.png' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip'>
                        {t('Hotel Software Demo')}
                    </div>
                    <h1 className='mt-3'>{t('Book Your Demo - See Prostay in Action')}</h1>
                    <p className='body-large'>
                        {t('Discover how Prostay can simplify operations, maximize revenue, and enhance guest experiences. Our team will walk you through the platform, showcasing the features that fit your property’s needs.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img className='center-content-img-width' src='/images/demorequest.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default DemoRequestHeader;
